import { studyDetailsCache } from "studydetails/StudyDetailsCache";

export function getStudySitesAlert(registryId: string) {
  const prefix = "To add, remove, or modify sites, please contact ";
  if (
    studyDetailsCache.has(registryId) &&
    studyDetailsCache.get(registryId)!.getVerilyCdm().length > 0
  ) {
    return prefix + studyDetailsCache.get(registryId)?.getVerilyCdm() + ".";
  } else {
    return prefix + "Verily DMs.";
  }
}
